import axios from 'axios'

const BASE_URL = 'https://ai-lab.hebei.com.cn/api/jyvote/api'
const UPLOAD_URL = 'https://appapi.hebei.com.cn/api/2026hbsyzbqzpzj/api'

const request = axios.create({
  timeout: 30000
})
const requestFile = axios.create({
  timeout: 120000
})
function stringifyData(data) {
  return JSON.stringify(data)
}

function postForm(url, params) {
  var data = new URLSearchParams()
  Object.keys(params).forEach(function(key) {
    data.append(key, typeof params[key] === 'string' ? params[key] : stringifyData(params[key]))
  })
  return request.post(url, data)
}

export function getVoteList(params) {
  return postForm(BASE_URL + '/list_fenye.php', { vid: stringifyData(params) })
}

export function searchVoteList(params) {
  return postForm(BASE_URL + '/search_fenye.php', { search: stringifyData(params) })
}

export function getVoteDetail(params) {
  return postForm(BASE_URL + '/detail.php', { pid: stringifyData(params) })
}

export function submitVote(params) {
  return postForm(BASE_URL + '/vote_70.php', { vote: stringifyData(params) })
}

export function uploadImage(file, onProgress) {
  var formData = new FormData()
  formData.append('file', file)
  return requestFile.post(UPLOAD_URL + '/imgupload.php', formData, {
    onUploadProgress: onProgress
  })
}

export function uploadFile(file, type, onProgress,videoUrl) {
	let url = ''
	if (type=='文字作品'||type=='计算机软件'||type=='其他作品'||type=='荣誉证明'||type=='补充材料') {
		url = 'fileupload.php';
	} else if (type=='口述作品'||type=='音乐作品'){
		// url = 'musicupload.php';
		url = videoUrl;
		return requestFile.put(videoUrl, file, {
			onUploadProgress: onProgress
		})
	} else if (type=='视频作品'){
		url = videoUrl;
		return requestFile.put(videoUrl, file, {
			onUploadProgress: onProgress
		})
	}else{
		url = 'imgupload.php';
	}
	var formData = new FormData()
	formData.append('file', file)
	return requestFile.post(UPLOAD_URL + '/' + url, formData, {
		onUploadProgress: onProgress
	})
}
export function getCityList(params) {
  return request.get(UPLOAD_URL + '/citylist.php')
}
export function getSubcategoryList(params) {
  return request.get(UPLOAD_URL + '/categorylist.php')
}

export function submitEntry(params) {
  
  return postForm(UPLOAD_URL + '/receive.php', { message: stringifyData(params) })
}

export function getBigFileUploadUrl(type) {
	if (type=='口述作品'||type=='音乐作品'){
		return request.get(UPLOAD_URL + '/musicupload.php')
	} else if (type=='视频作品'){
		return request.get(UPLOAD_URL + '/videoupload.php')
	}
  
}

export function visitLog() {
  return request.get(UPLOAD_URL + '/fwl.php')
}

export function getFileType(file) {
  var filename = file
  var index1 = filename.lastIndexOf('.')
  var index2 = filename.length
  return filename.substring(index1 + 1, index2)
}
